<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-tree
          :data="treeData"
          ref="tree"
          default-expand-all
          node-key="id"
          :expand-on-click-node="false"
          highlight-current
          :props="defaultProps"
          @node-click="handleNodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-if="data.id != 0 && treeId == data.id">
              <i
                class="el-icon-circle-plus-outline"
                @click.stop="setQx(data.id)"
              ></i>
            </span>
          </span>
        </el-tree>
      </el-col>
      <el-col :span="18">
        <el-button
          size="medium"
          v-if="roles.includes('/maintenance/type_add') && treeId == 0"
          type="primary"
          style="font-size: 14px; cursor: pointer"
          @click="addType(0)"
          >添加</el-button
        >
        <!-- <el-button
          type="info"
          circle
          icon="el-icon-refresh"
          style="font-size: 14px; cursor: pointer; float: right"
          @click="fetchData()"
        ></el-button> -->
        <el-table
          max-height="700"  v-loading="listLoading" 
          :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
          :data="list"
          element-loading-text="Loading"
          fit
          highlight-current-row
          stripe
          class="table-box"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          row-key="id"
          :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
        >
          <el-table-column label="序号" min-width="120">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" width="100"> </el-table-column>
          <el-table-column label="工单类型" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.title }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="上级工单类型" min-width="110" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.type == 1 ? "园区" : "企业" }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="标准响应时间(分钟)"
            min-width="110"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.response_time }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="标准处理时间(分钟)"
            min-width="110"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.processing_time }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" min-width="110" align="center">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.role_type == 1 ? '后台' : '小程序' }}</span> -->
              <el-tag
                :type="scope.row.status == '1' ? 'success' : 'danger'"
                disable-transitions
                >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
              >
            </template>
          </el-table-column>

          <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column> -->
          <el-table-column
            prop="created_at"
            label="操作"
            width="300"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                v-if="
                  roles.includes('/maintenance/type_add') &&
                  scope.row.level == 1 &&
                  treeId == 0
                "
                @click="addType(scope.row.id)"
                >添加</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="handleEdit(scope.row)"
                v-if="roles.includes('/maintenance/type_edit') && treeId == 0"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row.id)"
                v-if="roles.includes('/maintenance/type_del') && treeId == 0"
                >删除</el-button
              >
              <el-button
                class="szqxBtn"
                size="mini"
                type="primary"
                @click="wxRelevance(scope.row)"
                v-if="
                  roles.includes('/maintenance/set_mini_type_role') &&
                  treeId != 0
                "
                >关联角色</el-button
              >
              <!-- <el-button
                size="mini"
                type="primary"
                @click="appRelevance(scope.row)"
                v-if="
                  roles.includes('/maintenance/set_type_role') && treeId != 0
                "
                >关联角色</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-drawer
      size="700px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
        class="demo-ruleForm"
      >
        <el-form-item label="父级菜单名称" prop="pid">
          <SelectTree
            :props="props"
            :options="selectList"
            :value="ruleForm.pid"
            :disabled="true"
            @getValue="getValue($event)"
          />
        </el-form-item>
        <el-form-item label="工单类型名称" prop="title">
          <el-input
            v-model="ruleForm.title"
            :disabled="cztype == 'see'"
            placeholder="请输入工单类型名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否为硬件类型" prop="is_hardware">
          <el-radio-group v-model="ruleForm.is_hardware" :disabled="cztype == 'see'">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否计算逾期" prop="is_overdue">
          <el-radio-group
            v-model="ruleForm.is_overdue"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">不计算逾期</el-radio>
            <el-radio :label="2">计算逾期</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标准响应时间" prop="response_time">
          <el-row>
            <el-col :span="8">
              <el-form-item
                class="formItem"
                label-width="20px"
                label="天"
                prop="response_time"
              >
                <el-input-number
                  :min="0"
                  size="small"
                  v-model="ruleForm.response_time.day"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                class="formItem"
                label-width="20px"
                label="时"
                prop="response_time"
              >
                <el-input-number
                  :min="0"
                  :max="23"
                  size="small"
                  v-model="ruleForm.response_time.hour"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                class="formItem"
                label-width="20px"
                label="分"
                prop="response_time"
              >
                <el-input-number
                  :min="0"
                  :max="59"
                  size="small"
                  v-model="ruleForm.response_time.minute"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="标准处理时间" prop="processing_time">
          <el-row>
            <el-col :span="8">
              <el-form-item
                class="formItem"
                label-width="20px"
                label="天"
                prop="processing_time"
              >
                <el-input-number
                  :min="0"
                  size="small"
                  v-model="ruleForm.processing_time.day"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                class="formItem"
                label-width="20px"
                label="时"
                prop="processing_time"
              >
                <el-input-number
                  :min="0"
                  :max="23"
                  size="small"
                  v-model="ruleForm.processing_time.hour"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                class="formItem"
                label-width="20px"
                label="分"
                prop="processing_time"
              >
                <el-input-number
                  :min="0"
                  :max="59"
                  size="small"
                  v-model="ruleForm.processing_time.minute"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="工单原因类型设置" :visible.sync="qxdrawer">
      <tree-transfer
        :title="title"
        :from_data="fromData"
        :to_data="toData"
        :defaultProps="{ label: 'title', children: 'nodes' }"
        @addBtn="add"
        @removeBtn="remove"
        :mode="mode"
        height="400px"
      >
      </tree-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="qxdrawer = false">取 消</el-button>
        <el-button type="primary"  @click="set()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设置关联角色" :visible.sync="roleBox" width="800px">
      <el-form :model="roleForm" label-width="120px" class="demo-ruleForm">
        <!-- <el-form-item label="关联角色" prop="pid">
          <el-select filterable 
            v-model="roleForm.system_role_id"
            multiple
            collapse-tags
            style="margin-left: 20px;"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in roleList"
              :key="index"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <div>
          <el-form-item
            :label="'关联角色' + (index + 1)"
            v-for="(item, index) in domains"
            :key="item.system_role_id"
          >
            <el-select
              filterable
              @change="
                (id) => {
                  changeRole(id, index);
                }
              "
              class="w4"
              v-model="item.system_role_id"
              placeholder="请选择角色"
            >
              <el-option
                :disabled="roleIds.indexOf(item.id) != -1 ? true : false"
                :label="item.title"
                :value="item.id"
                v-for="(item, index) in roleList"
                :key="index"
              ></el-option>
            </el-select>
            <!-- <el-cascader
              class="w4"
              placeholder="请选择角色"
              :value="item.auth"
              :options="authList[index]"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                label: 'title',
                value: 'id',
                children: 'nodes',
                multiple: true
              }"
              clearable
              collapse-tags
            ></el-cascader> -->
            <el-select
              filterable
              class="w4"
              v-model="item.auth"
              placeholder="请选择权限"
              multiple
              collapse-tags
              @change="$forceUpdate()"
            >
              <el-option
                :label="item1.title"
                :value="item1.id"
                v-for="(item1, index1) in authList[index]"
                :key="index1"
              ></el-option>
            </el-select>
            <el-button
              style="margin: 0 0 0 10px"
              v-if="domains.length > 1 && cztype != 'see'"
              type="danger"
              @click.prevent="removeDomain(index)"
              >删除</el-button
            >
          </el-form-item>
        </div>
        <el-form-item v-if="userInfo.type != 2 && cztype != 'see'">
          <el-button type="primary" @click="addDomain">添加</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleBox = false">取 消</el-button>
        <el-button type="primary" @click="setRole()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  typeList,
  addType,
  infoType,
  eidtType,
  delType,
  setType,
  openPark,
  openRole,
  setTypeRole,
  getTypeRole,
  getMaintenanceAuth,
  set_mini_type_role,
  get_mini_type_role,
} from "@/api/index";
import { getToken } from "@/utils/auth";
import treeTransfer from "el-tree-transfer";
import SelectTree from "@/components/treeSelect/treeSelect.vue";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  components: { treeTransfer, SelectTree },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      curren: "0",
      roleForm: {
        maintenance_type_id: "",
        park_id: "",
        system_role_id: "",
      },
      roleBox: false,
      treeData: [
        {
          name: "园区管理",
          id: 0,
          children: [],
        },
      ],
      selectList: [
        {
          id: 0,
          title: "工单类型",
        },
      ],
      props: {
        // 配置项（必选）
        value: "id",
        label: "title",
        children: "nodes",
        // disabled:true
      },
      treeId: 0,
      defaultProps: {
        children: "children",
        label: "name",
      },
      title: ["待选", "已选"],
      mode: "transfer",
      fromData: [],
      toData: [],
      rightIds: [],
      qxdrawer: false,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加角色",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        is_page: 2,
        is_tree: 2,
        park_id: 0,
      },
      ruleForm: {
        title: "",
        is_overdue: 1,
        is_hardware: 2,
        response_time: { day: 0, hour: 0, minute: 0 },
        processing_time: { day: 0, hour: 0, minute: 0 },
        status: 1,
      },
      rules: {
        title: [
          { required: true, message: "请输入工单类型名称", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择角色类型", trigger: "change" },
        ],
        is_hardware: [
          { required: true, message: "请选择是否为硬件类型", trigger: "change" },
        ],
        role_type: [
          { required: true, message: "请选择关系所属", trigger: "change" },
        ],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
      },
      multipleSelection: [],
      cztype: "",
      oldImg: "",
      qxId: "",
      roleList: [],
      domains: [{ system_role_id: "", auth: "" }],
      roleIds: [],
      authList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.curren = this.userInfo.park_id;
      this.treeId = this.userInfo.park_id;
      this.screen.park_id = this.userInfo.park_id;
      this.screen.type = this.userInfo.type;
    } else {
      this.curren = "0";
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getpark();
  },
  mounted() {
    //方式二: 调用方法 来渲染默认项
    timer && clearTimeout(timer);
    var timer = setTimeout(() => {
      clearTimeout(timer);
      this.fetchTreeData();
    }, 200);
  },
  methods: {
    // 删除
    removeDomain(index) {
      this.roleIds = [];
      var i = this.roleIds.findIndex((item) => {
        return item == this.domains[index].company_id;
      });
      if (i != -1) {
        this.roleIds.splice(i, 1);
      }
      this.authList.splice(index, 1);
      this.domains.splice(index, 1);
    },
    // 角色
    changeRole(id, index) {
      if (!id) {
        return;
      }
      this.domains[index] = { system_role_id: id, auth: "" };
      this.roleIds = [];
      this.domains.forEach((item, index) => {
        if (item.system_role_id) {
          this.roleIds.push(item.system_role_id);
        }
      });
      this.getMAuth("add", id, index, this.facilityType + 1);
    },
    // 添加园区角色
    addDomain() {
      this.domains.push({ system_role_id: "", auth: "" });
    },
    fetchTreeData() {
      // 在 el-tree中 定义ref 来选中el-tree 调用setCurrentKey方法
      // 把想要高亮选中的项传入
      this.$refs.tree.setCurrentKey(this.curren);
    },
    // 设置角色
    setRole() {
      let data = {
        maintenance_type_id: this.roleForm.maintenance_type_id,
        park_id: this.roleForm.park_id,
        role_auth_rel_json: JSON.stringify(this.domains),
      };
      // return
      // this.roleForm.system_role_id = this.roleForm.system_role_id.toString();
      if (this.facilityType == 1) {
        set_mini_type_role(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.roleBox = false;
          }
        });
      } else {
        setTypeRole(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.roleBox = false;
          }
        });
      }
    },
    // 获取角色
    getRole() {
      openRole({ park_id: this.treeId, role_type: 2, type: 1,is_page:2 }).then((res) => {
        this.roleList = res.data.lists;
      });
    },
    // 获取节点
    getMAuth(type, id, index, menuType) {
    
      getMaintenanceAuth({
        park_id: this.treeId,
        menu_type: menuType,
        system_role_id: id,
      }).then((res) => {
        // this.authList = res.data.lists.data;
        if (type == "add") {
          this.$set(this.authList, index, res.data.lists);
        }
      });
    },
    getTypeRole(id, type) {
      console.log('公共啦啦啦啦啦')
      const data = {
        park_id: this.treeId,
        maintenance_type_id: id,
        only_role: 1,
      };
      var that = this;
      if (type == 1) {
        get_mini_type_role(data).then((res) => {
          console.log('gggggggg干撒个各色')
          // this.roleForm.system_role_id = res.data.lists;
          if (res.data.lists && res.data.lists.length > 0) {
            that.domains = [];
            that.domains = res.data.lists;
            that.domains.forEach((item, index) => {
              that.roleIds.push(item.system_role_id);
              console.log('ggg给个孤寡孤寡孤寡')
              that.getMAuth("add", item.system_role_id, index, type + 1);
            });
          }
        });
      } else {
        getTypeRole(data).then((res) => {
          // this.roleForm.system_role_id = res.data.lists;
          if (res.data.lists && res.data.lists.length > 0) {
            that.domains = [];
            that.domains = res.data.lists;
            that.domains.forEach((item, index) => {
              that.roleIds.push(item.system_role_id);
              that.getMAuth("add", item.system_role_id, index, type + 1);
            });
          }
        });
      }
    },
    // 打开关联角色
    wxRelevance(val) {
      (this.roleForm = {
        maintenance_type_id: "",
        park_id: "",
        system_role_id: "",
      }),
        (this.roleForm.maintenance_type_id = val.id);
      this.roleForm.park_id = this.treeId;
      (this.roleList = []),
        (this.domains = [{ system_role_id: "", auth: "" }]),
        (this.roleIds = []),
        (this.authList = []),
        this.getTypeRole(val.id, 1);
      this.getRole(2);
      this.facilityType = 1;
      this.roleBox = true;
    },
    // 打开关联角色
    appRelevance(val) {
      (this.roleForm = {
        maintenance_type_id: "",
        park_id: "",
        system_role_id: "",
      }),
        (this.roleForm.maintenance_type_id = val.id);
      this.roleForm.park_id = this.treeId;
      (this.roleList = []),
        (this.domains = [{ system_role_id: "", auth: "" }]),
        (this.roleIds = []),
        (this.authList = []),
        this.getTypeRole(val.id, 2);
      this.getRole();
      this.facilityType = 2;
      this.roleBox = true;
    },
    getValue(value) {
      this.ruleForm.pid = value;
    },
    handleNodeClick(data) {
      this.treeId = data.id;
      this.screen.park_id = data.id;
      this.fetchData();
    },
    set() {
      var ids = this.getRightDataIds(this.toData, []);
      setType({ park_id: this.qxId, id: ids.toString() }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
        this.fetchData();
        this.qxdrawer = false;
      });
    },
    // 获取右侧数据 id
    getRightDataIds(list, rightIds) {
      for (var rightItem of list) {
        rightIds.push(rightItem.id);
        if (rightItem.nodes && rightItem.nodes.length) {
          this.getRightDataIds(rightItem.nodes, rightIds);
        }
      }
      return rightIds;
    },
    // 处理过滤数据
    getFilterLeftData() {
      const rightIds = this.getRightDataIds(this.toData, []);
      this.fromData = this.filterLeftData(this.fromData, rightIds, []);
    },
    filterLeftData(list, rightIds, newList) {
      for (const leftItem of list) {
        if (rightIds.includes(leftItem.id)) {
          if (leftItem.nodes && leftItem.nodes.length) {
            let insetBool = false;
            for (const child of leftItem.nodes) {
              // if (!rightIds.includes(child.id)) insetBool = true
              if (rightIds.includes(child.id)) {
                if (child.nodes && child.nodes.length) {
                  for (const child1 of child.nodes) {
                    if (!rightIds.includes(child1.id)) insetBool = true;
                  }
                }
              } else {
                insetBool = true;
              }
            }
            if (insetBool) {
              const jsonItem = JSON.parse(JSON.stringify(leftItem));
              jsonItem.nodes = [];
              newList.push(jsonItem);
              this.filterLeftData(leftItem.nodes, rightIds, jsonItem.nodes);
            }
          }
        } else {
          const jsonItem = JSON.parse(JSON.stringify(leftItem));
          jsonItem.nodes = [];
          newList.push(jsonItem);
          this.filterLeftData(leftItem.nodes, rightIds, jsonItem.nodes);
        }
      }
      return newList;
    },
    // 设置权限
    setQx(id) {
      this.qxId = id;
      // infoType({ id: id }).then((res) => {
      //   if (res.data.info.is_super == 1) {
      //     this.getAuth(res.data.info.id, res.data.info.id);
      //   } else {
      //     this.getAuth(res.data.info.pid, res.data.info.id);
      //   }
      // });
      this.getAuth(id);
    },
    async getAuth(id) {
      await typeList({ is_page: 2, park_id: 0, is_tree: 2 }).then((res) => {
        this.fromData = res.data.list;
      });
      await typeList({ is_page: 2, park_id: id, is_tree: 2 }).then((res) => {
        this.toData = res.data.list;
      });
      this.getFilterLeftData();
      this.qxdrawer = true;
      // setTimeout(() => {
      // }, 1000)
    },
    // 监听穿梭框组件添加
    add(fromData, toData, obj) {
      // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
      // 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表
    },
    // 监听穿梭框组件移除
    remove(fromData, toData, obj) {
      // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
      // 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = JSON.parse(JSON.stringify(that.ruleForm));
          data.processing_time = this.globalfunc.swapMinute(
            data.processing_time
          );
          data.response_time = this.globalfunc.swapMinute(data.response_time);
          this.$confirm("确认提交？")
            .then(() => {
              eidtType(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.getInfo(val.id);
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.getInfo(val.id);
      // this.ruleForm = val
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delType({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    getInfo(id) {
      infoType({ id: id }).then((res) => {
        this.ruleForm = {
          id: res.data.info.id,
          pid: res.data.info.pid,
          title: res.data.info.title,
          is_overdue: res.data.info.is_overdue,
          is_hardware: res.data.info.is_hardware,
          response_time: this.globalfunc.minute(res.data.info.response_time),
          processing_time: this.globalfunc.minute(
            res.data.info.processing_time
          ),
          status: res.data.info.status,
        };
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = JSON.parse(JSON.stringify(that.ruleForm));
          data.processing_time = this.globalfunc.swapMinute(
            data.processing_time
          );
          data.response_time = this.globalfunc.swapMinute(data.response_time);
          this.$confirm("确认提交？")
            .then(() => {
              addType(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addType(id) {
      this.drawerTitle = "添加类型";
      this.cztype = "add";
      this.ruleForm = {
        pid: id,
        title: "",
        is_overdue: 1,
        is_hardware: 2,
        response_time: { day: null, hour: null, minute: null },
        processing_time: { day: null, hour: null, minute: null },
        status: 1,
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.drawer = true;
    },
    getpark() {
      openPark({ id: this.treeId, is_page: 2, status: 1 }).then((res) => {
        this.treeData[0].children = res.data.lists;
      });
    },
    delUser() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个角色");
        return;
      }
      this.$confirm("确认删除？")
        .then(() => {
          delType({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      typeList(this.screen).then((response) => {
        this.list = response.data.list;
        this.selectList = this.selectList.concat(response.data.list);
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
::v-deep .el-tree-node__content {
  height: auto !important;
}
::v-deep .custom-tree-node {
  font-size: 16px !important;
  line-height: 40px !important;
}
.table-box {
  margin-top: 20px;
}

.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}

.tableIcon {
  width: 50px;
  height: 50px;
}

.screenInput {
  width: 200px;
  margin: 0 10px;
}

.dialog-footer {
  text-align: center;
}

::v-deep .transfer-title {
  margin: 0;
}

::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  color: rgb(64, 158, 255);
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  .el-button--text {
    color: #ccc !important;
  }
}

::v-deep .formItem {
  .el-form-item__label {
    width: 0 !important;
    float: none !important;
  }

  .el-form-item__content {
    margin: 0 !important;
  }
}

::v-deep .el-tree-node__content {
  position: relative;
  .disabled {
    cursor: not-allowed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
  }
}
.szqxBtn {
  background: #40caff;
  margin-right: 10px;
}
</style>
